var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"section-label",style:(_vm.order > 1 && 'padding-top: 1.25rem')},[_vm._v(_vm._s(_vm.label))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.item)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }